import { Translation, useSafetyTranslation } from 'cng-common/features/translations'

import { PLAN_SECTION_DIALOG_TRANSLATION_KEYS } from '../translations'

import styles from './PlanSectionOverallNote.module.scss'

type PlanSectionOverallNoteProps = {
  /** Translation key of the section the dialog was showing, the one its tab carries. */
  section: string
}

/**
 * Takes the section's place while `Overall` is picked over an open section it does not have: the
 * dialog stays open and says how to get the section back.
 */
export const PlanSectionOverallNote = ({ section }: PlanSectionOverallNoteProps) => {
  const t = useSafetyTranslation()

  return (
    <div className={styles.root}>
      <span className={styles.title}>
        <Translation text={PLAN_SECTION_DIALOG_TRANSLATION_KEYS.overallTitle} span />
      </span>
      <span className={styles.hint}>
        <Translation
          text={PLAN_SECTION_DIALOG_TRANSLATION_KEYS.overallHint}
          replaceParams={[{ key: '{section}', value: t(section) }]}
          span
        />
      </span>
    </div>
  )
}

PlanSectionOverallNote.displayName = 'PlanSectionOverallNote'
